// ActivityThreeQuestion.jsx — Tablet activity (Phase 3: real logic).
// Matches room.php's #myModal3 / .option-btn behavior: single selection
// (brown), Submit only enabled once one option is picked, green/red on
// submit, and — if the wrong option was picked — the correct option (position
// 2) gets highlighted green ~1s later too (room.php's `.correct-answer`
// class, applied via a setTimeout after the wrong pick).
import React, { useState } from 'react';
import ActivityPopup from '../overlays/ActivityPopup';
import { TABLET_QUESTION, TABLET_OPTIONS } from '../../../games/escape-to-inner-peace/data/gameText';
import '../../../games/escape-to-inner-peace/styles/theme.css';
import './ActivityThreeQuestion.css';

const CORRECT_POSITION = 2;
const REVEAL_DELAY_MS = 1000;
const COMPLETE_DELAY_MS = 1500;

function ActivityThreeQuestion({ open, onComplete }) {
  const [selected, setSelected] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [feedback, setFeedback] = useState({});

  const handleSelect = (position) => {
    if (submitted) return;
    setSelected(position);
  };

  const handleSubmit = () => {
    if (submitted || selected === null) return;
    setSubmitted(true);

    const isCorrect = selected === CORRECT_POSITION;
    setFeedback({ [selected]: isCorrect ? 'correct' : 'incorrect' });

    if (!isCorrect) {
      setTimeout(() => {
        setFeedback((prev) => ({ ...prev, [CORRECT_POSITION]: 'reveal-correct' }));
      }, REVEAL_DELAY_MS);
    }

    setTimeout(() => {
      onComplete(isCorrect ? 1 : 0);
    }, (isCorrect ? 0 : REVEAL_DELAY_MS) + COMPLETE_DELAY_MS);
  };

  const optionClass = (position) => {
    if (feedback[position]) return `escape-option-btn escape-option-btn--${feedback[position]}`;
    if (selected === position) return 'escape-option-btn escape-option-btn--selected';
    return 'escape-option-btn';
  };

  return (
    <ActivityPopup
      open={open}
      title={TABLET_QUESTION}
      plainHeader
      testId="escape-activity-tablet"
      footer={
        <button
          type="button"
          className="escape-submit-btn"
          disabled={selected === null || submitted}
          aria-label="Submit"
          data-testid="escape-tablet-submit"
          onClick={handleSubmit}
        />
      }
    >
      <div className="escape-options-container">
        {TABLET_OPTIONS.map((option) => (
          <button
            key={option.position}
            type="button"
            className={optionClass(option.position)}
            aria-pressed={selected === option.position}
            data-testid={`escape-tablet-option-${option.position}`}
            onClick={() => handleSelect(option.position)}
            disabled={submitted}
          >
            {option.text}
          </button>
        ))}
      </div>
    </ActivityPopup>
  );
}

export default ActivityThreeQuestion;
